// src/utilities/element-utils.ts
function hasTextWrapped(el) {
  if (!el)
    return false;
  const computedStyle = window.getComputedStyle(el);
  const fontSize = parseFloat(computedStyle.getPropertyValue("font-size"));
  const lineHeight = parseFloat(computedStyle.getPropertyValue("line-height"));
  const marginTop = parseFloat(computedStyle.getPropertyValue("margin-top"));
  const marginBottom = parseFloat(computedStyle.getPropertyValue("margin-bottom"));
  const paddingTop = parseFloat(computedStyle.getPropertyValue("padding-top"));
  const paddingBottom = parseFloat(computedStyle.getPropertyValue("padding-bottom"));
  const borderTop = parseFloat(computedStyle.getPropertyValue("border-top-width"));
  const borderBottom = parseFloat(computedStyle.getPropertyValue("border-bottom-width"));
  const textHeight = Math.max(fontSize, lineHeight);
  const spacing = marginTop + marginBottom + paddingTop + paddingBottom + borderTop + borderBottom;
  return el.clientHeight >= textHeight + spacing;
}
function hasOverflown(el) {
  if (!el)
    return false;
  return el.scrollWidth > el.clientWidth && el.scrollWidth - el.clientWidth > 1;
}
function getTag(el) {
  if (!("tagName" in el))
    return void 0;
  const { tagName } = el;
  return tagName.toLowerCase();
}
function hasTag(el, tagName) {
  if (!el)
    return false;
  return getTag(el) === tagName.toLowerCase();
}
function getElement(el, tagName) {
  if (!hasTag(el, tagName))
    return void 0;
  const result = el;
  return result;
}
function hasShadowParent(element) {
  while (element) {
    if (element instanceof ShadowRoot) {
      return true;
    }
    element = element.parentNode;
  }
  return false;
}
function getShadowParent(element) {
  while (element) {
    if (element.parentNode && element.parentNode instanceof ShadowRoot) {
      return element;
    }
    element = element.parentNode;
  }
  return void 0;
}
function applyExternalStyles(el, styles) {
  const shadowParent = getShadowParent(el.parentNode);
  const parent = shadowParent ? shadowParent : document.body;
  const id = `${el.tagName.toLowerCase()}-global-style`;
  if (!(parent == null ? void 0 : parent.querySelector(`#${id}`))) {
    const styleElement = document.createElement("style");
    styleElement.id = id;
    styleElement.textContent = styles.toString();
    parent == null ? void 0 : parent.append(styleElement);
  }
}

export {
  hasTextWrapped,
  hasOverflown,
  getTag,
  hasTag,
  getElement,
  hasShadowParent,
  getShadowParent,
  applyExternalStyles
};
